var _g, _path, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "india 1",
    clipPath: "url(#clip0_1205_41270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1205_41270",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 13
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.787109 0.19043H16.7871V12.1904H0.787109V0.19043Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1205_41270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.787109 0.19043V12.1904H16.7871V0.19043H0.787109Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1205_41270",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 13
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.787109 0.19043V12.1904H16.7871V0.19043H0.787109Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1205_41270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.787109 0.19043V4.19043H16.7871V0.19043H0.787109Z",
    fill: "#FF8C1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.787109 8.19043V12.1904H16.7871V8.19043H0.787109Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78711 6.19043C6.78711 7.29498 7.68256 8.19043 8.78711 8.19043C9.89166 8.19043 10.7871 7.29498 10.7871 6.19043C10.7871 5.08586 9.89166 4.19043 8.78711 4.19043C7.68256 4.19043 6.78711 5.08586 6.78711 6.19043ZM10.2871 6.19043C10.2871 7.01888 9.61556 7.69043 8.78711 7.69043C7.95866 7.69043 7.28711 7.01888 7.28711 6.19043C7.28711 5.36198 7.95866 4.69043 8.78711 4.69043C9.61556 4.69043 10.2871 5.36198 10.2871 6.19043Z",
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78431 6.62075L8.49891 8.18105L8.66466 6.60355L7.95121 8.0202L8.55466 6.5533L7.47101 7.7116L8.46326 6.47415L7.09716 7.2802L8.39791 6.3724L6.86006 6.76095L8.36381 6.2564L6.77881 6.1959L8.36381 6.13545L6.86006 5.6309L8.39791 6.01945L7.09716 5.11166L8.46326 5.9177L7.47101 4.68025L8.55466 5.83855L7.95121 4.37164L8.66466 5.7883L8.49891 4.21082L8.78431 5.7711L9.06976 4.21082L8.90401 5.7883L9.61746 4.37164L9.01401 5.83855L10.0977 4.68025L9.10541 5.9177L10.4715 5.11166L9.17076 6.01945L10.7086 5.6309L9.20486 6.13545L10.7899 6.1959L9.20486 6.2564L10.7086 6.76095L9.17076 6.3724L10.4715 7.2802L9.10541 6.47415L10.0977 7.7116L9.01401 6.5533L9.61746 8.0202L8.90401 6.60355L9.06976 8.18105L8.78431 6.62075Z",
    fill: "#3D58DB"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1205_41270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white",
    transform: "translate(0.787109 0.19043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/india-flag.b9e14a5c9e6abfa990a65d8001bfd4e9.svg";
export { ForwardRef as ReactComponent };